import { Usuario } from "../despacho/Usuario";

export class Grupo{
  id: string;
  titulo: string;
  roles: number[];
  usuarios: Usuario[];
  activo: boolean;
}